var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"externalContainer"},[_c('leftPublicTree',{attrs:{"type":"external","updatePersonList":_vm.updatePersonList}}),_c('rightPublicTable',{ref:"rightPublicTable",attrs:{"type":"external"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }